let html = `<div class="wrap layer--height layer--width">
    <div class="wrap__left wrap__left--hidden layer--height"></div>
    <div class="wrap__content layer--height layer--width"></div>
</div>`

export default html